import LoginForm from './LoginForm'
import enhance from './LoginForm.enhancer'

export default enhance(LoginForm)



// WEBPACK FOOTER //
// ./src/components/organisms/LoginForm/index.js